var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3871 44.0999H12.137C9.43084 44.0999 7.23704 41.9061 7.23706 39.1999L7.23725 9.8C7.23727 7.09381 9.43107 4.90002 12.1372 4.90002H34.1878C36.894 4.90002 39.0878 7.09383 39.0878 9.80002V19.6M15.8128 14.7H30.5128M15.8128 22.05H30.5128M30.5128 31.756V37.7675C30.5128 40.738 33.6803 43.4625 36.6508 43.4625C39.6214 43.4625 42.7628 40.738 42.7628 37.7675V30.1741C42.7628 28.6014 41.8587 27.0055 39.8477 27.0055C37.6962 27.0055 36.6508 28.6014 36.6508 30.1741V37.4511M15.8128 29.4H23.1628",
    stroke: "#00123A",
    strokeWidth: 4.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttach);
export default __webpack_public_path__ + "static/media/FileAttach.bf092e0225b36559944cddff1a0df61b.svg";
export { ForwardRef as ReactComponent };